import RichUpdatesItemMedia from './RichUpdatesItemMedia';

export default RichUpdatesItemMedia;
